import { Cpf } from "models/domain/cpf.domain";
import { Zipcode } from "models/domain/zipcode.domain";
import { RoleTypes } from "models/role-types.model";
import { z } from "zod";

export type UserData = {
    accessToken: string;
    refreshToken: string;
    expiresIn: number;
    userToken: {
        id: string;
        email: string;
    };
}

export type UserInformation = {
    id: string;
    name: string;
    cpf: string;
    email: string;
    birthDate: Date;
    phoneNumber: string;
    roles: RoleTypes[];
    address: {
        state: string,
        city: string,
        neighborhood: string,
        streetName: string,
        streetType: string,
        addressNumber: string,
        addressComplement?: string,
        zipcode?: Zipcode
    };
}


export const loginCredentialsSchema = z.object({
    cpf: z.string({ required_error: 'CPF é obrigatório.' })
        .length(14, { message: 'Preencha com o seu CPF.' })
        .refine((cpf) => {
            try {
                Cpf.fromString(cpf);
                return true
            } catch (err) {
                return false;
            }
        }, { message: 'CPF em formato inválido.' }),
    password: z.string({ required_error: 'Senha é obrigatório.' })
        .min(6, { message: 'É obrigatório no mínimo 6 caracteres.' })
});

export type LoginCredentials = z.infer<typeof loginCredentialsSchema>;